<template>
    <div id="wapper">
        <!--  v-if="sidebar.opened" -->
        <nav class="navbar-default navbar-static-side" role="navigation" :id="sidebar.opened == 1?'page-slidebar':''">
            <layout-leftmenu></layout-leftmenu>
        </nav>
        
        <div class="gray-bg" :id="sidebar.opened == 1 ? 'page-wrapper':'slider_bar'" style="padding: 0">
            <div class="row border-bottom" style="margin-left: 0; margin-right: 0;">
                <layout-header></layout-header>
            </div>
            <div class="main-content">
                <div class="hhsoft-tab">
                    <layout-tab></layout-tab>
                </div>
                
                <div class="tab-content">
                    <layout-main></layout-main>
                </div>
            </div>
            <div class="footer" :class="sidebar.opened == 1 ? 'fixed':'fixedbar'">
                <layout-bottom></layout-bottom>
            </div>
        </div>

        
    </div>
</template>

<script>
import ResizeMixin from '@/components/layout/mixin/ResizeHandler'
import layoutHeader from '@/components/layout/LayoutHeader.vue'
import layoutLeftmenu from '@/components/layout/LayoutLeftMenu.vue'
import layoutMain from '@/components/layout/LayoutMain.vue'
import layoutBottom from '@/components/layout/LayoutBottom.vue'
import layoutTab from '@/components/layout/LayoutTab.vue'

import { mapState } from 'vuex'
import $ from 'jquery'

export default {
    mixins: [ResizeMixin],
    data(){
        return {
            
        }
    },
    components:{
        layoutHeader,
        layoutLeftmenu,
        layoutMain,
        layoutBottom,
        layoutTab
    },
    mounted:function(){
        $('.tab-content').css('height',($(window).height()-$('.tab-content').offset().top-80)+'px')

    },
    computed:{
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            }
        }
      }
}
</script>

<style scoped>
.hhsoft-tab{
    background-color: #fff;
}
.tab-content{
    width: 98%;
    margin: 10px auto;
    overflow-y:auto;
    overflow-x: hidden;
}
/* .tab-content::-webkit-scrollbar {
    display: none;
}

.tab-content {
    scrollbar-width: none;
    -ms-overflow-style: none;
    overflow-x: hidden;
    overflow-y: auto;
} */
.main-content{
    padding-bottom: 20px;
}
.sidebar-collapse{
        width: 20px;
    }
</style>
